import { generateUrl } from "@services/generateUrl/generateUrl";
import axiosApiInstance from "@services/custom-axios-instance";
import { APIResponse, IGeneralInfo, IPublicProfileGeneralInfo } from "@interfaces/patient/public-profile";
import { ApiResponse, IAwardsAndCertification } from "@interfaces/practititoner/profile/public-profile";
import drProxPractitionerApiInstance from "@services/clients/drproxpractitioner";

export function postProfilePhoto(
    username: string,
    role: string,
    file: FormData
) {
    return axiosApiInstance
        .post(
            `${generateUrl()}/storage/storage/profile/picture?rol=${role}&username=${username}`,
            file
        )
        .then((response) => {
            return response.data;
        });
}

/**
 * Get public profile general info for current logged user
 */
export async function getPublicProfileInfo(): Promise<IGeneralInfo> 
{
    const endpoint = "/api/v1/practitioner/profile/general";
    const response = await drProxPractitionerApiInstance.get<IGeneralInfo>(endpoint);
    return response.data;
}

/**
 * Updates the public profile general info info
 * @param username    Practitioner username
 * @param info        New information
 */
export async function updatePublicProfileInfo(info: IPublicProfileGeneralInfo) 
{
    const endpoint = "/api/v1/practitioner/profile/general";
    const response = await drProxPractitionerApiInstance.post<APIResponse>(endpoint, info);
    return response.data;
}

/**
 * Save an award and certification
 * @param username  Target username
 * @param data      Award data
 */
export async function postAwardsAndCertification(data: IAwardsAndCertification): Promise<ApiResponse> 
{
    const endpoint = "api/v1/practitioner/profile/awards-certifications";
    const response = await drProxPractitionerApiInstance.post<ApiResponse>(endpoint, data);
    return response.data;
}

/**
 * Retrieves awards and certifications
 * @param username  Target username
 */
export async function getAwardsAndCertifications(username: string): Promise<IAwardsAndCertification[]>
{
    const endpoint = `/api/v1/practitioner/profile/awards-certifications/${username}`;
    const response = await drProxPractitionerApiInstance.get<IAwardsAndCertification[]>(endpoint);
    return response.data;
}

/**
 * Delete awards and certifications
 * @param awardCertId Award certification to delete
 */
export async function deleteAwardsAndCertification(awardCertId: string): Promise<ApiResponse> 
{
    const endpoint = `/api/v1/practitioner/profile/awards-certifications/${awardCertId}`;
    const response = await drProxPractitionerApiInstance.delete<ApiResponse>(endpoint);
    return response.data;
}

export async function updateAwardsAndCertification(data: IAwardsAndCertification): Promise<ApiResponse> 
{
    const endpoint = "/api/v1/practitioner/profile/awards-certifications";
    const response = await drProxPractitionerApiInstance.put<ApiResponse>(endpoint, data);
    return response.data;
}
